import {Controller} from "stimulus"

export default class extends Controller {

    static targets = [
        "form"
    ]

    initialize(){
        console.log("filtrer les images");
    }

    submit(){
        this.formTarget.submit();
    }

}